module.exports = __webpack_public_path__ + "static/media/johan.25827ebd.gif";